import {IPaginatedResult} from '../incase-domain/search';

export const getNextPage = (lastPage: IPaginatedResult<unknown> | undefined): number | undefined => {
    if (!lastPage) return undefined;
    if (lastPage.pageNumber * lastPage.pageSize < lastPage.numberOfElements) {
        return lastPage.pageNumber + 1;
    }
    return undefined;
};
